import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63bb37cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-grid p-p-2",
  style: {"height":"95%","width":"98%","margin-left":"10px"}
}
const _hoisted_2 = { class: "p-col-12 p-shadow-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "month-item" }
const _hoisted_5 = ["download", "href"]
const _hoisted_6 = {
  key: 0,
  class: "p-col-12 p-shadow-2",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "p-col-12 p-shadow-2",
  style: {"height":"100%","width":"100%","overflow":"scroll"}
}
const _hoisted_9 = { class: "container" }
const _hoisted_10 = ["src", "title"]
const _hoisted_11 = {
  key: 2,
  class: "p-col-12 p-shadow-2",
  style: {"height":"100%","width":"100%","overflow":"scroll"}
}
const _hoisted_12 = { class: "container" }
const _hoisted_13 = ["src", "title"]
const _hoisted_14 = {
  key: 3,
  class: "p-col-12 p-shadow-2",
  style: {"height":"100%","width":"100%","overflow":"scroll"}
}
const _hoisted_15 = { class: "container" }
const _hoisted_16 = {
  key: 4,
  class: "p-col-12 p-shadow-2",
  style: {"height":"100%","width":"100%","overflow":"scroll"}
}
const _hoisted_17 = { class: "container" }
const _hoisted_18 = {
  key: 5,
  class: "p-col-12 p-shadow-2 justify-content: center;",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_19 = { class: "p-col-12 p-p-4" }
const _hoisted_20 = { class: "loadingSpinner" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-close-octagon-outline",
  style: {"fontSize":"8rem"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = {
  key: 1,
  class: "p-grid"
}
const _hoisted_24 = { class: "p-col-12 p-p-4" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-p-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loadingSpinner" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "mdi mdi-spin mdi-loading",
      style: {"fontSize":"8rem"}
    })
  ])
], -1))
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.record.attachments && _ctx.record.attachments.length > 0 && _ctx.record.currentDocumentBase64)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            "model-value": _ctx.selectedDocument,
            onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDocument($event))),
            options: _ctx.record.attachments,
            placeholder: "",
            style: {"max-width":"31.25rem"}
          }, {
            value: _withCtx((slotProps) => [
              (slotProps.value.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", null, _toDisplayString(slotProps.value.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            option: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(slotProps.option.name), 1)
            ]),
            _: 1
          }, 8, ["model-value", "options"]),
          _createTextVNode("  "),
          _createElementVNode("a", {
            download: _ctx.selectedDocument.name,
            href: 'data:;base64, ' + _ctx.selectedDocument.documentBase64
          }, [
            _withDirectives(_createVNode(_component_Button, {
              class: "p-button-md",
              icon: "mdi mdi-folder-download-outline"
            }, null, 512), [
              [
                _directive_tooltip,
                _ctx.$t('Freeze.Eas.Download'),
                void 0,
                { bottom: true }
              ]
            ])
          ], 8, _hoisted_5)
        ]),
        (_ctx.selectedDocument.name.toLowerCase().indexOf('.pdf') !== -1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("iframe", {
                src: _ctx.createPdfUrlPath(_ctx.selectedDocument.documentBase64),
                style: {"height":"100%","width":"100%"},
                width: "100%"
              }, null, 8, _hoisted_7)
            ]))
          : ((_ctx.selectedDocument.name.toLowerCase().indexOf('.jpg') !== -1 || _ctx.selectedDocument.name.toLowerCase().indexOf('.jpeg') !== -1))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    class: "base64Image",
                    src: 'data:image/jpeg;base64, ' + _ctx.selectedDocument.documentBase64,
                    title: _ctx.selectedDocument.name
                  }, null, 8, _hoisted_10)
                ])
              ]))
            : ((_ctx.selectedDocument.name.toLowerCase().indexOf('.png') !== -1))
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      class: "base64Image",
                      src: 'data:image/png;base64, ' + _ctx.selectedDocument.documentBase64,
                      title: _ctx.selectedDocument.name
                    }, null, 8, _hoisted_13)
                  ])
                ]))
              : ((_ctx.selectedDocument.name.toLowerCase().indexOf('.json') !== -1))
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("pre", null, _toDisplayString(_ctx.decodeJSON(_ctx.selectedDocument.documentBase64)), 1)
                    ])
                  ]))
                : ((_ctx.selectedDocument.name.toLowerCase().indexOf('.txt') !== -1) || _ctx.selectedDocument.name.toLowerCase().indexOf('.csv') !== -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("pre", null, _toDisplayString(_ctx.decodeText(_ctx.selectedDocument.documentBase64)), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Freeze.SearchMask.NoPreview')), 1)
                        ])
                      ])
                    ]))
      ]))
    : (_ctx.record.attachments && _ctx.record.attachments.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('Freeze.Eas.NoDocument')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
}